<template>
  <div class="news-all">
    <div class="title">
      <span class="time">
        06.17
        <br />2016
      </span>
      <span class="tiel">美菜刘传军：新鲜低价是品牌，企业文化是命脉！</span>
    </div>
    <div class="mat-content">
      <p align="center">
        <img
          src="https://img-oss.yunshanmeicai.com/cfile/15a18ef51239bc15546b9b1648a7abd1.jpg"
          width="640"
        />
      </p>
      <div
        class="tet-js"
      >美菜网创始人兼CEO刘传军，于6月2日在美菜总作战部接受了媒体记者的采访。刘传军称：“我创办美菜是出于对农村的情怀和对土地的热爱。通过互联网的方式来改变农业、农村和农民，是我的一个夙愿。”美菜2年将企业规模扩大到数万人，在生鲜B2B领域主打”新鲜低价”的品牌概念。通过构建一套独特的企业文化和商业模式，成功占据了国内生鲜电商最大的一块阵地。</div>
    </div>
    <div class="mat-content">
      <div class="title-bold">
        <span></span>美菜的受众是餐厅，请问刘总怎么看待B2B平台对受众选择的问题？
      </div>
      <div
        class="tet-js"
      >刘传军说：美菜在创业初期的时候，曾进行2B两个市场的尝试，一个是菜市场，一个是餐厅。我们研究分析：餐厅主要通过购买生鲜食材，加工成高附加值的商品为消费者提供餐饮服务，后期的毛利高达60％以上。而菜市场恰恰相反，采购来的菜需要高品质的的呈现给消费客户，但是只有很低的附加值。所以美菜认为，餐厅更符合我们的受众定位，我们自建物流体系，源头直采一站式对接餐厅。B2B平台对受众选择一定要符合公司的战略和业务，才能找准双方最佳利益点，例如美菜主打“新鲜低价”，就正迎合了餐厅对菜品的需求。</div>
    </div>
    <div class="mat-content">
      <div class="title-bold">
        <span></span>请问美菜为什么坚持源头直采？物流体系是如何快速建立的？
      </div>
      <div class="tet-js">
        刘传军说：源头直采可以保证菜品“新鲜、低价”。我们不妨将源头直采看成是田间到餐厅的直通车，因为取消了中间环节，从而大大缩短了生鲜食材采摘后送到餐厅的时间。这不仅最大程度的保留了菜品的新鲜度，还避免了多梯次批发层层加价，从而保证菜品低价。
        <br />
        <br />其次，美菜有一套自己的军事化管理体系和一套严谨的文化构建系统，其价值观和文化愿景并得到每一位员工的认同和践行。我们要求一线物流司机要将新鲜的食材准时送达餐厅，因为时间和速度是生鲜命脉。曾经就有一个北京的司机犯了肾结石，还咬着牙坚持准时的把产品送到了餐厅，让我们非常触动。一个企业若没有相同的信仰和拼搏的毅力，很难发展起来。物流也是一样，构建体系很容易，但是要想快速发展，还需要文化和价值观的统一。
        <p align="center" style="padding: 30px 0 10px;">
          <img
            src="https://img-oss.yunshanmeicai.com/cfile/fa699f87544ad90a49c0e33c91df3798.jpg"
            width="640"
          />
        </p>
      </div>
    </div>
    <div class="mat-content">
      <div class="title-bold">
        <span></span>听说美菜有着极其独特的企业文化，可以表述吗？
      </div>
      <div class="tet-js">
        刘传军说：我自己对历史是有很深刻的研究的，美菜与农民密不可分，于是我一直在研究毛主席是如何带领广大农村取得革命胜利的。我们借鉴毛主席的战略，成立了美菜总政治部，每个分公司都有政委，每个物流配送都有指导员，还有自己类似新华社的虚拟电台，做公司的文化和“新鲜低价”的品牌传递。
        <br />
        <br />我曾经一直很好奇：当年的革命根据地遍布大江南北，毛主席是如何保持革命斗志的呢？其实，现在的美菜如同那个时候的共产党，全国20多家分公司就如同当年的根据地，要农民和合伙人和我们有一样的价值取向和文化氛围，才可以把美菜管理好，才可以把革命干成。
      </div>
    </div>
    <div class="mat-content">
      <div class="title-bold">
        <span></span>听说6月份美菜要举办两周年庆典活动，可以稍微介绍一下这是一个什么样的活动吗？
      </div>
      <div class="tet-js">
        整个6月份都是美菜的庆典月，是针对全国中小餐厅持续一个月的生鲜促销购买活动。叫美菜“66季”，主打“新鲜低价”品牌。
        <br />
        <br />新鲜是保证菜品的品质，有三个优势：一个是短流通，菜品品质一定会随着时间而流失，所以流通环节一定要短；二是短操作，如果对菜品的触摸和操作越少，菜品的品质会越好；三是冷链物流，美菜物流配送采用自建冷链体系，8-10个小时就能完成从田间到餐厅的流通。
        <br />
        <br />低价是价格优势：美菜采用的是源头直采，砍掉层层抽成的中间商，冷链物流一站式对接餐厅，所以价格比起传统采购来说自然降低了许多。
      </div>
    </div>
    <div class="mat-content">
      <div class="title-bold">
        <span></span>中国农产品市场是非常大的，美菜将来有什么打算吗？
      </div>
      <div class="tet-js">
        美菜会坚定不移的走下去，不断提供“新鲜低价”的产品服务餐厅。同时不断的累积规模，不断渗透，把美菜的基地遍布全中国。农业的变革只有一种可能，就是有一家公司可以累积足够的农产品规模，而且足够稳定。
        <br />
        <br />目前，美菜已经和海外市场洽谈合作，几年下来将会累积可观的规模来保证它的竞争力。美菜坚信可以改变传统农业的落后面貌，为农业现代化的发展献上一份力！
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "new-a2"
};
</script>

<style lang="scss" scoped>
</style>
